import React from 'react';
import { PageNotFoundContainer } from './PageNotFound.styled';

export const PageNotFound = () => (
  <PageNotFoundContainer data-testid="PageNotFound">404</PageNotFoundContainer>
);
